module.exports = {
  pagination: {
    of: 'de',
    page: 'Page',
    previousPage: 'Page précédente',
    nextPage: 'Page suivante',
  },
  select: {
    placeholder: 'Choisir...',
  },
  table: {
    add: 'Ajouter',
    noTableData: 'Aucune donnée trouvée.',
    subtotal: 'Sous-total',
  },
};



// WEBPACK FOOTER //
// ./js/lang/fr/components.js